import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_API_URL;

const AdminService = {
  getLocations() {
    return axios.get(`${API_URL}/admin/locations`, { headers: authHeader() });
  },

  getAllUsers() {
    return axios.get(`${API_URL}/admin/users`, { headers: authHeader() });
  },

  getUserAccesses(username) {
    return axios.get(`${API_URL}/admin/users/${username}/accesses`, { headers: authHeader() });
  },

  assignAccess(username, locationFunctionId) {
    return axios.post(
      `${API_URL}/admin/users/${username}/accesses`,
      { locationFunctionId },
      { headers: authHeader() }
    );
  },

  revokeAccess(username, userLocationFunctionId) {
    return axios.delete(
      `${API_URL}/admin/users/${username}/accesses/${userLocationFunctionId}`,
      { headers: authHeader() }
    );
  },

  // Invitations
  createInvitation(email, locationId) {
    return axios.post(`${API_URL}/admin/invitations`, { email, locationId }, { headers: authHeader() });
  },

  getInvitations() {
    return axios.get(`${API_URL}/admin/invitations`, { headers: authHeader() });
  },

  getPendingUsers() {
    return axios.get(`${API_URL}/admin/invitations/pending-users`, { headers: authHeader() });
  },

  // Audit
  getExecutionLogs() {
    return axios.get(`${API_URL}/admin/audit/executions`, { headers: authHeader() });
  },

  getSecurityEvents() {
    return axios.get(`${API_URL}/admin/audit/security`, { headers: authHeader() });
  },

  // Client status
  getClientStatus() {
    return axios.get(`${API_URL}/admin/clients/status`, { headers: authHeader() });
  },
};

export default AdminService;
